import request from './request';

export function getPost({ type, id, preview }) {
  const params = { type, ...(preview !== undefined && { preview }) };

  return request('get', `/apiv2/posts/${id}`, params);
}
